/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
export default class RefChecker {
	constructor(subject){
		let validRef = new WeakMap();
		validRef.set(subject, true);
		this.isValid = function() {
			return (validRef.has(subject));
		};

		this.remove = function() {
			validRef.delete(subject);
		};
	}
}



// WEBPACK FOOTER //
// ./src/js/lib/@waca/ref-checker/src/js/RefChecker.js